import { quickAccess } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const toneStyles: Record<string, { badge: string; icon: string }> = {
  primary: {
    badge: "bg-primary-100 text-primary-800",
    icon: "bg-primary-500 text-background-50 dark:text-foreground-950",
  },
  accent: {
    badge: "bg-accent-100 text-accent-900",
    icon: "bg-accent-500 text-background-50 dark:text-foreground-950",
  },
  secondary: {
    badge: "bg-secondary-100 text-secondary-900",
    icon: "bg-secondary-500 text-background-50 dark:text-foreground-950",
  },
};

export default function QuickAccess() {
  return (
    <section id="access" className="w-full bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <SectionHeading
          eyebrow="观看入口"
          title="四条主通道，直接对号入座"
          desc="先想清楚你想用哪种方式看，再从下面四个入口进入对应区块，比盲目搜索快得多。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {quickAccess.map((item) => {
            const tone = toneStyles[item.tone] ?? toneStyles.primary;
            return (
              <a
                key={item.id}
                href={item.anchor}
                className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              >
                <div className="relative h-36 w-full overflow-hidden bg-background-200">
                  <img
                    src={item.cover}
                    alt={`${item.title}配图`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span
                    className={`absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-md ${tone.icon}`}
                  >
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {item.desc}
                  </p>
                  <ul className="mt-4 flex flex-wrap gap-2">
                    {item.tags.map((tag) => (
                      <li
                        key={tag}
                        className={`rounded-full px-2.5 py-1 font-label text-xs ${tone.badge}`}
                      >
                        {tag}
                      </li>
                    ))}
                  </ul>
                  <span className="mt-4 inline-flex items-center gap-1 font-label text-sm text-primary-700">
                    进入该区块
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}